const BOARD_MEMBER_PROFILE = 'hoa_coa_board_member';
const ELEVATED_PROFILES = [
    'admin',
    'owner',
    'property_manager',
    'agent',
];
export function isRestrictedBoardMember(user) {
    if (!user)
        return false;
    return (user.profiles.includes(BOARD_MEMBER_PROFILE) &&
        !ELEVATED_PROFILES.some((profile) => user.profiles.includes(profile)));
}
//# sourceMappingURL=boardMemberAccess.js.map